import { TFunction } from 'i18next'

import { LocalitiesStatus } from 'src/api/requests'

type LocalizedTitleProps = {
  item?: {
    translation?: {
      ro?: string
      ru?: string
    }
    status?: LocalitiesStatus | null
  } | null
  t: TFunction
  currentLang: 'ro' | 'ru'
}

export const formatIdnp = (value: string) => {
  return value.slice(0, 4) + '******' + value.slice(10)
}

export const parseToken = (token: string | null) => token && JSON.parse(token)

export const getLocalizedTitle = ({
  item,
  t,
  currentLang
}: LocalizedTitleProps) => {
  if (!item) return

  const status = item?.status ? `(${t('localities.' + item.status)})` : ''

  return currentLang === 'ro'
    ? `${item?.translation?.ro} ${status}`
    : `${item?.translation?.ru} ${status}`
}

export const removeCuatmStauts = (label?: string) => {
  return label?.split('(')[0].trim()
}
